import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class HeaderService {
  private _title = signal<string>('');
  readonly title = this._title.asReadonly();

  private _actions = signal<any[]>([]);
  readonly actions = this._actions.asReadonly();

  setTitle(title: string): void {
    this._title.set(title);
  }

  getTitle(): string {
    return this._title();
  }

  removeTitle(): void {
    this._title.set('');
  }

  setActions(actions: any[]): void {
    this._actions.set(actions);
  }

  getActions(): any[] {
    return this._actions();
  }

  removeActions(): void {
    this._actions.set([]);
  }
}
